<div [ngStyle]="styles" tiptapDraggable [ngClass]="{ editable: isEditable, selected: isEditable && selected() }">
    <h4>Product Description</h4>
    <p>Payment for $22 was received on April 21, 2025 3:45 PM.</p>
</div>
